export default function ConfirmationModal({ text, onConfirm, onCancel }) {
  return (
    <div className="fixed inset-0 flex items-center justify-center" role="dialog" aria-modal="true">
      <div className="bg-purple-600 text-white p-4 rounded-2xl shadow-lg w-80 text-center">
        <p className="text-lg font-medium mb-4">{text}</p>
        <div className="flex justify-center gap-4">
          <button
            onClick={onConfirm}
            className="bg-white text-purple-600 hover:bg-purple-200 py-1 px-3 rounded"
          >
            Yes
          </button>
          <button
            onClick={onCancel}
            className="bg-white text-purple-600 hover:bg-purple-200 py-1 px-3 rounded"
          >
            No
          </button>
        </div>
      </div>
    </div>
  );
}
